import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch, batch } from "react-redux";
import CircularLoading from "../loader/CircularIndeterminate";

const VogaEnquiry = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      clientname: values.clientname,
      clientphone: values.clientphone,
      course_id: values.course_id,
      month: values.month,
      batch_name: values.batch_name,
      is_enquiry: values.is_enquiry,
      is_online_payment: values.is_online_payment,
    };
    dispatch(actions.postCourse(coursereg, setSubmitting, resetForm));
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientphone: "",
                  course_id: "611",
                  month: "",
                  batch_name: "",
                  is_enquiry: "1",
                  is_online_payment: "0",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                  course_id: Yup.string().required("required"),
                  month: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  formProps.values.totalfees = formProps.values.month * 999;
                  return (
                    <Form className="mt-3">
                      {console.log("formProps", formProps.values)}
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="clientname" className="label">
                            Your Full Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="clientphone" className="label">
                            Your Whatsapp Number:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Whatsapp Number"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      {/* number_of_month */}
                      {/* <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="number_of_month" className="label">
                            Minimum number of months for riyaaz:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="number_of_month"
                              id="number_of_month"
                              placeholder="Enter Minimum number of months for riyaaz"
                              className={
                                "form-control" +
                                (formProps.errors.number_of_month &&
                                formProps.touched.number_of_month
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="number_of_month"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row> */}
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="month" className="label">
                            Number of months:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="month"
                              id="month"
                              placeholder="Enter Number of months"
                              className={
                                "form-control" +
                                (formProps.errors.month &&
                                formProps.touched.month
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>
                                Select Number of months
                              </option>
                              <option value={"2"}>2</option>
                              <option value={"3"}>3</option>
                              <option value={"4"}>4</option>
                            </Field>
                            <ErrorMessage
                              name="month"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="batch_name" className="label">
                            Select Your Batch:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="batch_name"
                              id="batch_name"
                              placeholder="Enter Your Batch"
                              className={
                                "form-control" +
                                (formProps.errors.batch_name &&
                                formProps.touched.batch_name
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Your Batch</option>
                              <option value={"Mon-Wed-Fri (Morning 7 AM)"}>
                                Mon-Wed-Fri (Morning 7 AM)
                              </option>
                              <option value={"Mon-Wed-Fri (Evening 5 PM)"}>
                                Mon-Wed-Fri (Evening 5 PM)
                              </option>
                            </Field>
                            <ErrorMessage
                              name="batch_name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <InputGroup>
                            <Field type="checkbox" name="checked" value="One" />

                            <span className="radiobtn">
                              {" "}
                              &nbsp; Hereby,Please Accept Terms & Condition
                            </span>
                            <ErrorMessage
                              name="branch"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* <h4 className="text-center p-3 mt-3">
                      To register for Voga Experience (Level 1), Kindly contact
                      us at +91 7400 377748
                    </h4> */}
                      <div className="mt-3 mb-3 row mt-3">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? (
                              <CircularLoading />
                            ) : (
                              "REGISTER NOW"
                            )}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default VogaEnquiry;
